<template>
  <div class="pagination">
    <b-dropdown :text="`${perPage} Rows`" class="m-md-2" right>
      <b-dropdown-header class="title">Rows per page</b-dropdown-header>
      <b-dropdown-item
        :class="{ selected: perPage === 10 }"
        @click="changeRows(10)"
        >10 Rows</b-dropdown-item
      >
      <b-dropdown-item
        :class="{ selected: perPage === 20 }"
        @click="changeRows(20)"
        >20 Rows</b-dropdown-item
      >
      <b-dropdown-item
        :class="{ selected: perPage === 30 }"
        @click="changeRows(30)"
        >30 Rows</b-dropdown-item
      >
      <b-dropdown-item
        :class="{ selected: perPage === 40 }"
        @click="changeRows(40)"
        >40 Rows</b-dropdown-item
      >
      <b-dropdown-item
        :class="{ selected: perPage === 50 }"
        @click="changeRows(50)"
        >50 Rows</b-dropdown-item
      >
    </b-dropdown>

    <i
      class="material-icons"
      :class="{ disabled: page <= 1 }"
      @click="decrement()"
      >chevron_left</i
    >
    <input type="text" v-model="page" /><span> of {{ pageCount }}</span>
    <i
      class="material-icons"
      :class="{ disabled: page >= pageCount }"
      @click="increment()"
      >chevron_right</i
    >
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  data() {
    return {
      debounce_timer: null,
    };
  },
  computed: {
    page() {
      return this.$store.getters.page;
    },
    perPage() {
      return this.$store.getters.perPage;
    },
    total_projects() {
      return this.$store.getters.total_projects;
    },
    pageCount() {
      return Math.ceil(this.total_projects / this.perPage);
    },
  },
  watch: {
    page() {
      if (this.page) {
        if (typeof this.page === 'string') {
          this.$store.dispatch('setPage', parseInt(this.page, 10));

          if (isNaN(this.page)) {
            this.$store.dispatch('setPage', 1);
          }
        }

        if (typeof this.page === 'number') {
          if (this.page < 1) {
            this.$store.dispatch('setPage', 1);
          } else if (this.page > this.pageCount) {
            this.$store.dispatch('setPage', this.pageCount);
          }
        }

        this.debounce();
      }
    },
    pageCount() {
      // this.$store.dispatch('setPage', 1)
      // this.$store.dispatch('incrementPaginationTrigger')
    },
    perPage() {
      this.$store.dispatch('setPage', 1);
      this.$store.dispatch('incrementPaginationTrigger');
    },
  },
  methods: {
    debounce() {
      this.$store.dispatch('setLoading', true);

      if (this.debounce_timer) {
        clearTimeout(this.debounce_timer);
      }

      this.debounce_timer = setTimeout(() => {
        this.debounce_timer = null;
        this.$store.dispatch('incrementPaginationTrigger');
      }, 350);
    },
    changeRows(num) {
      this.$store.dispatch('setPerPage', num);
    },
    increment() {
      if (this.page < this.pageCount) {
        this.$store.dispatch('setPage', this.page + 1);
      }
    },
    decrement() {
      if (this.page > 1) {
        this.$store.dispatch('setPage', this.page - 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: 15px;

  input {
    width: 38px;
    height: 38px;
    border-radius: 4px;
    border: 1px solid #e2e5ec;
    text-align: center;
    font-size: 13px;
    font-weight: 500;
    outline: none;
    margin: 0;

    &:focus,
    &:active {
      border-color: #acb6c1;
    }
  }

  span {
    font-size: 13px;
    font-weight: 500;
    margin: 0 6px;
    color: $light-color;
  }

  ::v-deep .dropdown {
    margin: 0 !important;
    width: auto;
  }

  ::v-deep .btn.dropdown-toggle {
    border-radius: 4px;
    border: 1px solid #e2e5ec !important;
    width: 100px;
    padding: 6px 12px;
    font-size: 13px;
    font-weight: 500;
    color: $light-color !important;
    margin-top: 0px;
    margin-right: 15px;
    height: 38px;

    &:hover {
      border-color: #acb6c1 !important;
      color: $sidebar-inactive !important;
    }

    &:after {
      right: 14px;
    }
  }

  ::v-deep .dropdown-menu {
    width: auto;
  }

  > i {
    user-select: none;
    cursor: pointer;
    font-size: 20px;
    padding: 3px;
    color: #acb6c1;

    &.disabled {
      cursor: not-allowed;
      color: #d8dee5;
    }
  }
}
</style>
